import { isExternalLink } from '@/utils/isExternalLink';
import clsx from 'clsx';
import Link from 'next/link';

type Props = {
  menuItems?: {
    _key: string;
    label: string | null;
    link: string | null;
  }[];
  pathname?: string;
  theme?: 'white' | 'dark' | null;
  closeNav?: () => void;
};

function MenuItems({ menuItems, pathname, closeNav, theme }: Props) {
  return (
    <>
      {menuItems && menuItems.length > 0 ? (
        <ul className={clsx("flex flex-col gap-5 text-center text-xl font-semibold uppercase lg:flex-row lg:text-lg", {
          'text-white': theme === 'white',
          'text-black': theme === 'dark',
        })}>
          {menuItems.map(({ _key, label, link }) => (
            <li
              key={_key}
              className={clsx('lg:hover:underline', {
                underline: '/artikler' === pathname,
              })}
              onClick={closeNav}
            >
              {isExternalLink(link || '') ? (
                <a href={link || '/'} target="_blank" rel="noreferrer">
                  {label}
                </a>
              ) : (
                <Link href={link || '/'}>{label}</Link>
              )}
            </li>
          ))}
        </ul>
      ) : null}
    </>
  );
}

export default MenuItems;
